module.exports = __webpack_public_path__ + "static/starry-night-waterfall-c01171521b0916c202e985f7d0b0c2c8.png";